export const QUIZ_TIMER:string = 'quiz-timer'

export const QUIZ_ANSWERS:string = 'quiz-answers'